<template>
    <b-modal ref="my-modal" okTitle="OK" ok-only @ok="emitOkEvent">
        {{message}}
    </b-modal>
</template>

<style scoped>
</style>

<script>
export default {
    name: 'AlertDialog',
    components: {
    },
    props: [],
    data() {
        return {
            message: null,
        }
    },
    computed: {
    },
    methods: {
        open(message) {
            this.message = message
            this.showModal()
        },
        isOpen() {
            return this.$refs['my-modal'].isVisible
        },
        showModal() {
            this.$refs['my-modal'].show()
        },
        hideModal() {
            this.$refs['my-modal'].hide()
        },
        countChanged(event) {
            this.count = event.value
        },
        emitOkEvent() {
            this.$emit('ok', {
            })
        },
    },
}
</script>
